import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./PlayerProgress.css";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";
import { secsToTime } from "../../../util/CommonFunc";
import clsx from "clsx";
import waveNotFound from "../../../images/wave-not-found.png";
import { setWaveformUrl } from "redux/actions/PlayerActions";

const wavFormBase = 'https://soundmouse-pictures.assets.soundmouse.com';

class Player extends Component {
  constructor() {
    super();
    this.state = {
      audioPlayer: new Audio(),
      imageChecked: false,
      originalAsset: null,
    };
  }

  componentDidMount() {
    this.updateWaveformUrl();
  }

  componentDidUpdate(prevProps) {
    const { track } = this.props.player;
    if (track !== prevProps.player.track) {
      this.updateWaveformUrl();
    }
  }

  updateWaveformUrl = () => {
    const { player: { track }, setWaveformUrl } = this.props;

    if (track) {
      const originalAsset = track.assets?.find(f => f.quality === 2147483647)?.key;

      if (originalAsset !== this.state.originalAsset) {
        this.setState({ originalAsset, imageChecked: false });

        if (!originalAsset) {
          setWaveformUrl(waveNotFound);
          this.setState({ imageChecked: true });
        } else {
          const waveUrl = `${wavFormBase}/${originalAsset}.png`;
          this.imageAvailabilityCheck(waveUrl, isAvailable => {
            setWaveformUrl(isAvailable ? waveUrl : waveNotFound);
            this.setState({ imageChecked: true });
          });
        }
      }
      else{
        setWaveformUrl(waveNotFound);
      }
    }
  }

  imageAvailabilityCheck = (url, callback) => {
    const img = new Image();
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
    img.src = url;
  }

  render() {
    const {
      classes,
      player: { track, bufferProgress, playProgress, playDuration, playTime, isPlaying, waveformUrl },
      locate,
      item,
    } = this.props;

    const progress = playDuration >= 0 ? `${secsToTime(playTime ?? 0)} / ${secsToTime(playDuration)}` : null;

    return (
      <Translation>
        {(t, { i18n }) =>
          track && (item ? track.id === item.id : true) && waveformUrl ? (
            <div className={clsx(classes.root, "popupWave")}>
              <div className={classes.waveForm}>
                <img
                  alt=""
                  className={waveformUrl === waveNotFound ? "waveImageInBuilt" : "waveImage"}
                  src={waveformUrl}
                />
              </div>
              <span className={clsx(classes.TrackDuration, "duration-container")}>
                {progress}
              </span>
              <LinearProgress
                classes={{
                  colorPrimary: classes.colorPrimary,
                  barColorPrimary: classes.barColorPrimary,
                  dashedColorPrimary:
                    isPlaying && bufferProgress === 0
                      ? classes.dashedColorPrimaryActive
                      : classes.dashedColorPrimary,
                }}
                onClick={e => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const position = ((e.clientX - rect.left) / e.currentTarget.offsetWidth) * playDuration;
                  locate(position);
                }}
                variant="buffer"
                value={playProgress}
                valueBuffer={bufferProgress}
              />
            </div>
          ) : (
            <LinearProgress
              className={clsx(classes.root, classes.barSize)}
              classes={{
                colorPrimary: classes.colorPrimary,
                barColorPrimary: classes.barColorPrimary,
                dashedColorPrimary: classes.dashedColorPrimary,
              }}
              variant="buffer"
              value={0}
              valueBuffer={0}
            />
          )
        }
      </Translation>
    );
  }
}

Player.propTypes = {
  player: PropTypes.object.isRequired,
  setWaveformUrl: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setWaveformUrl,
};

const mapStateToProps = (state) => ({
  player: state.player,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Player));
